export const contentPanelId = (id: string) => `tabpanel_${id}`;
export const labelId = (id: string, value: number) => `tabpanel_${id}_tab_${value}`;
